module.exports = __webpack_public_path__ + "media/src/images/printer-064a6a8c37ebc559be40e68658794208.png";